import React, {Component} from 'react'
import { withApollo } from 'react-apollo'
import { Tabs, Typography, Spin, Row, Col, Input, message } from 'antd'
import { Queries, Mutations } from '../../../../graphql'
import Container from '../../../../components/user/Container'
import TabsBlockProFile from '../../../../components/user/TabsBlockProFile'
import { datasetsProfileDetail, tabProfile } from '../../../../config/datasetsProfile'
import { checkType } from '../../../../utils/checkType'
import { pushAge } from '../../../../utils/formatdate'
import moment from 'moment'

const { TabPane } = Tabs
const { Text, Title } = Typography

const newsDataProfile = '';

class ProFileList extends Component {
	state = {
		detailProfile : [],
		dataNewProfile : {},
		loaddingDataNews : false
	}

	fetchProfile = async () =>{
		try {
			const { client, location } = this.props

			const { data, errors } = await client.query({
				query: Queries.detchProfileListDetail,
			})

			console.log(data)

			this.setState({
				detailProfile: data
			})
		} catch (error) {
			// const errorMessage = error.graphQLErrors[0].message
			// message.error("Token is expired.")
		}
	}

    inputForm = (title, values, keyInput) =>{
		return(
			keyInput == 'input' && 
				<Col xs={24} sm={12} className="mb-3">
					<div className="">
						<Text>
							{ title }
						</Text><br></br>
						<Input 
							value={ values ? values : 'ไม่พบข้อมูล' } 
							className={ values ? values : 'font-italic' } 
							disabled={true}
						/>
					</div>
				</Col>
			||
			<Col xs={24} sm={12} className="mb-3">
					<div className="">
						<Text>
							{ title }
						</Text><br></br>
						<Input.TextArea 
							value={ values ? values : 'ไม่พบข้อมูล' } 
							className={ values ? values : 'font-italic' } 
							autoSize="2"
							disabled={true}
						/>
					</div>
				</Col>
		)
	}

    tabsOne = () =>{
		const { detailProfile } = this.state
		console.log(detailProfile)
		return (
			<TabPane tab={'ข้อมูลส่วนตัว'} key="1" className="mb-0">
				<Row gutter={16}>
					<Col xs={24} md={24} className="mb-2">
						<strong className="color-red">
                            ข้อมูล
						</strong>
					</Col>
                    <>
                        { this.inputForm('เลขบัตรประชาชน', detailProfile.fetchProfile ? detailProfile.fetchProfile.identityCard ? detailProfile.fetchProfile.identityCard : '' : '', 'input') }
                        { this.inputForm(
								'ชื่อ', 
								detailProfile.fetchProfile ? detailProfile.fetchProfile.name ? detailProfile.fetchProfile.name : '' : '',
								'input'
							)
						}
                        { this.inputForm(
								'ชื่อ(Eng)', 
								detailProfile.fetchProfile ? detailProfile.fetchProfile.firstNameEng+detailProfile.fetchProfile.lastNameEng ? detailProfile.fetchProfile.firstNameEng+' '+detailProfile.fetchProfile.lastNameEng : '' : '', 'input' 
							) 
						}
                        { this.inputForm('วันเกิด', detailProfile.fetchProfile ? detailProfile.fetchProfile.birthDate ? checkType(detailProfile.fetchProfile.birthDate) : '' : '', 'input' ) }
                        { this.inputForm('อายุ', detailProfile.fetchProfile ? detailProfile.fetchProfile.birthDate ? pushAge(detailProfile.fetchProfile.birthDate) : '' : '', 'input') }
                        { this.inputForm(
								'เพศ', 
								detailProfile.fetchProfile ? detailProfile.fetchProfile.gender ? checkType(detailProfile.fetchProfile.gender) : '' : '',
								'input'
							) 
						}
                        { this.inputForm(
								'หมู่เลือด', 
								detailProfile.fetchProfile ? detailProfile.fetchProfile.bloodGroups ? checkType(detailProfile.fetchProfile.bloodGroups) : '' : '',
								'input'
							) 
						}
                        { this.inputForm(
								'สัญชาติ', 
								detailProfile.fetchProfile ? detailProfile.fetchProfile.nationality ? checkType(detailProfile.fetchProfile.nationality) : '' : '',
								'input'
							) 
						}
                        { this.inputForm(
								'เชื้อชาติ', 
								detailProfile.fetchProfile ? detailProfile.fetchProfile.race ? checkType(detailProfile.fetchProfile.race) : '' : '',
								'input'
							) 
						}
                        { this.inputForm(
								'ศาสนา', 
								detailProfile.fetchProfile ? detailProfile.fetchProfile.religion ? checkType(detailProfile.fetchProfile.religion) : '' : '',
								'input'
							) 
						}

						 { this.inputForm(
                                'โทรศัพท์ (มือถือ)', 
                                detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.phone1 ? detailProfile.fetchEmployeeProfile.address.phone1 : '' : '',
                                'input'
                            ) 
						}

                        { this.inputForm(
								'อีเมล', 
								detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.email1 ? detailProfile.fetchEmployeeProfile.address.email1 : '' : '',
								'input'
							) 
						}
                        {/* { this.inputForm(
								'โทรศัพท์ (มือถือ)', 
								detailProfile.fetchEmployeeProfile ? detailProfile.fetchEmployeeProfile.address.phone1 ? detailProfile.fetchEmployeeProfile.address.phone1 : '' : '',
								'input'
							) 
						} */}
                    </>
				</Row>
			</TabPane>
		)
	}

	async componentDidMount(){
		await this.fetchProfile()
    }

	render() {
		const { history, location, match, staticContext } = this.props
		const { loaddingDataNews, dataNewProfile, detailProfile} = this.state
		return (
			<Container match={match}>
				<div className="card-container" id="page-profile">
					<div className="px-5 py-1 card-bg-green">
						{
							detailProfile.length !== 0 &&
							<Tabs type="card" style={{borderBottom:"6px solid #d7222a"}} className="my-4">
								{ this.tabsOne() }
							</Tabs>
						}
						
					</div>
				</div>
			</Container>
		)
	}
}

ProFileList.propTypes = {
	//
}

export default withApollo(ProFileList)
